import api from '@/api'
import * as types from './types'

export default {
  initWorkOrderMaintenance({ commit }) {
    commit(types.INIT_WORKORDER)
  },
  async addInsurance({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.addInsurance(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async getWorkOrderMaintenance({ commit, dispatch }, workOrder) {
    return new Promise((resolve, reject) => {
      api.getWorkOrderMaintenance(workOrder)
        .then(response => {
          commit(types.SET_WORKORDER, response.data)
          resolve(response)
        })
    })
  },
  async saveWorkOrderMaintenance({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.saveWorkOrderMaintenance(data)
        .then(response => {
          resolve(response)
        })
    })
  },
  async fixDispatchTimes({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      api.fixDispatchTimes()
        .then(response => {
          resolve(response)
        })
    })
  },
  async cancelPendingRequests({ commit, dispatch }, location) {
    return new Promise((resolve, reject) => {
      api.cancelPendingRequests(location)
        .then(response => {
          resolve(response)
        })
    })
  },
  async searchTechnicians({ commit, state, dispatch }, searchTerm) {
    return new Promise((resolve, reject) => {
      api.searchTechnicians(searchTerm)
        .then(response => {
          console.log('Search Techs', response)
          var _technicians = []
          for (var tech of response.data) {
            var technician = {
              name: tech.FamilyName + ', ' + tech.GivenName + ' (' + tech.Username + ')',
              code: tech.Id,
              lastName: tech.FamilyName
            }
            _technicians.push(technician)
          }
          commit(types.SET_TECHNICIANS, _technicians)
          resolve(_technicians)
        })
    })
    // console.log('Search Techs', data)
    // var _technicians = []
    // for (var tech of data.data) {
    //   var technician = {
    //     name: tech.FamilyName + ', ' + tech.GivenName + ' (' + tech.Username + ')',
    //     code: tech.Id,
    //     lastName: tech.FamilyName
    //   }
    //   _technicians.push(technician)
    // }
    // commit(types.SET_TECHNICIANS, _technicians)
    // return _technicians
  },
  async resetTechnician({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      api.resetTechnician(data)
        .then(response => {
          resolve(response)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/maintenance/actions.js